/**Dependencies */
import React from "react";
import useForm from "../hooks/useForm";
import { Autoplay } from "swiper/modules";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaPhoneAlt,
} from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import Swal from "sweetalert2";
/**Styles */
import "../styles/contacto.scss";

/**Images */
import fotoAgencia from "../images/Foto de la agencia.png";
import comentario1 from "../images/Comentario 1.png";
import comentario2 from "../images/Comentario 2.png";
import comentario3 from "../images/Comentario 3.png";
import comentario4 from "../images/Comentario 4.png";

// Services
import { getEmailText } from "../services/emailService";

export const Contacto = () => {
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    fullName: "",
    email: "",
    age: "",
    phone: "",
    message: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  const submitForm = async () => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje: `Nombre completo: ${formData.fullName} \nEmail: ${formData.email} \nNúmero de teléfono: ${formData.phone} \nMensaje: ${formData.message}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };
  return (
    <div className="contacto">
      <PrincipalBanner idElemento={10} />
      <Container className="py-5">
        <div className="text-center">
          <h1 className="section-title">Contacto</h1>
        </div>
      </Container>
      <Container>
        <div className="mb-2">
          <h1 style={{ fontSize: "35px", fontWeight: 700 }}>
            ¿Tienes alguna pregunta?
          </h1>
        </div>
      </Container>

      <Container
        className="section-contacto container"
        fluid
        style={{ padding: "50px 0", position: "relative" }}
      >
        <Row className="align-items-center">
          <Col lg={6} md={12} className="section-contacto__img-container p-0">
            <img
              src={fotoAgencia}
              alt="Agencia de Viajes"
              className="section-contacto__img-agencia"
            />
          </Col>

          <Col
            lg={6}
            md={12}
            className="d-flex justify-content-center align-items-center position-relative"
            style={{ minHeight: "400px" }}
          >
            <div className="section-contacto__form-container">
              <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
                <Form.Group controlId="formNombre">
                  <Form.Label>Nombre Completo</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Correo electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPhone" className="mb-3">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    maxLength={10}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formMessage" className="mb-3">
                  <Form.Label>Mensaje</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={formData.message}
                    rows={3}
                    name="message"
                    onChange={handleChange}
                    className="input-light text-white"
                  />
                </Form.Group>
                <div className="d-flex justify-content-center pt-5">
                  <Button variant="light" type="submit" className="btn-white">
                    Enviar
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="info-contact" style={{ padding: "50px 0" }}>
        <Container>
          <Row className="text-center">
            <Col
              lg={4}
              xs={12}
              md={6}
              className="d-flex justify-content-center mb-3"
            >
              <div className="info-contact__box-style">
                <h5>Teléfonos</h5>
                <p className="">
                  <FaWhatsapp /> 777 203 5097 <br />
                  <FaWhatsapp /> 777 179 0074 <br />
                  <FaPhoneAlt /> 777 312 5765 <br />
                  <FaPhoneAlt /> 777 312 8531 <br />
                  <FaPhoneAlt /> 777 318 9115
                </p>
              </div>
            </Col>

            <Col
              lg={4}
              xs={12}
              md={6}
              className="d-flex justify-content-center mb-3"
            >
              <div className="info-contact__box-style">
                <h5>Dirección</h5>
                <p>
                  Vicente Guerrero 110
                  <br />
                  Int.9 Col. Lomas de la Selva,
                  <br />
                  Cuernavaca Morelos C.P. 62270
                </p>
              </div>
            </Col>

            <Col
              lg={4}
              xs={12}
              md={6}
              className="d-flex justify-content-center mb-3"
            >
              <div className="info-contact__box-style">
                <h5>Correo</h5>
                <p>contacto@tranet.com.mx</p>
                <h6>Síguenos en:</h6>
                <p>
                  <FaFacebook />{" "}
                  <a
                    href="https://www.facebook.com/ViajesTranet"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-white"
                  >
                    International Travel Net
                  </a>
                  <br />
                  <FaInstagram />{" "}
                  <a
                    href="https://www.instagram.com/travelnetcuerna?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-white"
                  >
                    @travelnetcuerna
                  </a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="py-5">
        <div className="carrusel-contenedor">
          <Swiper
            direction="vertical"
            spaceBetween={30}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Autoplay]}
            className="mySwiper"
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            <SwiperSlide>
              <img
                src={comentario1}
                alt={"comentario 1"}
                style={{ width: "100%" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={comentario2}
                alt={"comentario 2"}
                style={{ width: "100%" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={comentario3}
                alt={"comentario 3"}
                style={{ width: "100%" }}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={comentario4}
                alt={"comentario 4"}
                style={{ width: "100%" }}
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};
